import { Icons } from "@ir/ui";
import { useAnalyticsScoreCards } from "@/hooks";
import AnalyticsScoreCard, { ScoreCardConfig } from "./AnalyticsScoreCard";

const CONFIG: ScoreCardConfig = {
  title: "Unresolved Deductions",
  theme: "warning",
  icon: Icons.Clock,
};

const UnresolvedDeductionsCard = () => {
  const { unresolvedDeductions } = useAnalyticsScoreCards();
  return <AnalyticsScoreCard config={CONFIG} data={unresolvedDeductions} />;
};

export default UnresolvedDeductionsCard;
